import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteSABannersStart, getAllAffiliateStart, getAllSABannersStart, updateAffiliateStatusStart, updateSABannerStart, uploadSABannerStart } from '../../../store/redux-slices/superAdminSettings'
import useCheckPermission from '../../../utils/checkPermission'
import useDidMountEffect from '../../../utils/useDidMountEffect'
import { useNavigate } from 'react-router-dom'

const useAffiliateManagement = () => {
  const { loading, affiliateRequests } = useSelector(state => state.superAdminSettings)
  const navigate = useNavigate() 
  const isInitialRender = useDidMountEffect()
  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const { clientsFilterData, portalsFilterData } = useSelector(state => state.tenants)
  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const [type, setType] = useState('')
  const [data, setData] = useState({})
  const [show, setShow] = useState(false)
  const [showAffiliateModal, setShowAffiliateModal] = useState(false)
  const [selectedUser,setSelectedUser] = useState(null)
  const dispatch = useDispatch()
  const { isHidden } = useCheckPermission()
  const totalPages = Math.ceil(affiliateRequests?.count / limit)
  const [validation, setValidation] = useState({
    minRequiredWidth: '',
    minRequiredHeight: '',
    maxRequiredWidth: '',
    maxRequiredHeight: ''
  })

  useEffect(() => {
    if (data?.bannerType) {    
        setValidation({
          minRequiredWidth: 200,
          minRequiredHeight: 200,
          maxRequiredWidth: 300,
          maxRequiredHeight: 300
        })
    }
  }, [data])

  useEffect(() => {
    setPage(1)
    dispatch(
      getAllAffiliateStart({
        limit: limit,
        pageNo: page,
      })
    )
  }, [limit])

  useEffect(() => {
    !isInitialRender && dispatch(
      getAllAffiliateStart({
          limit: limit,
          pageNo: page,
        })
    )
  }, [page])

  useEffect(() => {
    setPage(1)
    getAllAffiliateStart()
  }, [limit])

  const handleCreateEdit = (type, data) => {
    setType(type)
    setData(data)
    setShow(true)
  }


  const handleDelete = (name) => {
    dispatch(deleteSABannersStart({name}))
    dispatch(
      getAllSABannersStart({
        limit: limit,
        pageNo: page,
      })
    )
  }

  const createUpdate = (data) => {
     dispatch(updateAffiliateStatusStart({
        data: data,
        limit: '',
        pageNo: ''
      }))
  }

  return {
    loading,
    selectedClient,
    setSelectedClient,
    selectedPortal,
    setSelectedPortal,
    affiliateRequests,
    handleCreateEdit,
    type,
    data,
    setShow,
    show,
    createUpdate,
    clientsFilterData,
    portalsFilterData,
    dispatch,
    isHidden,
    validation,
    setValidation,
    handleDelete,
    page,
    limit,
    setPage,
    setLimit,
    setShowAffiliateModal,
    showAffiliateModal,
    selectedUser,
    setSelectedUser,
    totalPages,
    navigate
  }
}

export default useAffiliateManagement
